import { cn } from "@/lib/utils";

const ITEMS = [
  "House Cleaning",
  "Deep Cleaning",
  "Move-In / Move-Out",
  "Office Cleaning",
  "Post-Construction",
  "Wetumpka",
  "Millbrook",
  "Prattville",
  "Montgomery",
  "Tallassee",
  "Eclectic",
];

/**
 * Slow infinite horizontal marquee on blush, gold ✦ separators.
 * Pauses on hover. Pure CSS animation.
 */
export function Marquee({ className }: { className?: string }) {
  const row = (
    <span className="marquee-track">
      {ITEMS.map((t) => (
        <span key={t} className="mx-4 inline-flex items-center gap-4">
          <span className="font-display text-lg font-semibold text-pink-deep md:text-xl">{t}</span>
          <span className="text-gold">✦</span>
        </span>
      ))}
    </span>
  );

  return (
    <div
      className={cn(
        "surface-blush grain marquee-wrap relative overflow-hidden py-4 md:py-5",
        className,
      )}
      aria-hidden
    >
      <div className="flex w-max">
        {row}
        {row}
      </div>
    </div>
  );
}
